/*
 * Get-orders.ts
 * Description: Includes the declaration
 * of get orders functions
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex store variable
import {store} from '@/config/plugins';

/**
 * Getting a list of all user orders
 *
 * @return {Object} Promise - a list of all user orders
 */
export function getOrders() {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'orders',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Getting a list of all restaurant orders
 *
 * @return {Object} Promise - a list of all restaurant orders
 * @param {String} slug - id of an restaurant
 */
export function getRestaurantOrders(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/orders',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

